import { ToothSvgComponentProps } from '@/modules/patientList/patientStrip/patientStripOdontogram/types';

const SvgNormal = (props: ToothSvgComponentProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16 * (props.wx ?? 1)}
    height={23 * (props.hx ?? 1)}
    viewBox="0 0 16 23"
    fill="none"
    className={props.className}
  >
    <path
      fill={props.fill || '#E4E4E7'}
      stroke={props.stroke || '#A1A1AA'}
      strokeLinejoin="round"
      d="M8 21.383c1.2 0 4.317 1.628 6.117-.406 1.443-1.63.91-5.551-.124-8.19-.385-.981-.4-1.92-.301-2.974.468-5.04-.504-8.485-2.157-8.579-1.242-.07-1.26 8.621-3.617 8.104S6.748 1 5.089 1C3.431 1 2.075 4.532 2.31 9.813c.046 1.058.083 1.993-.302 2.975-1.034 2.639-1.567 6.56-.124 8.19 1.8 2.033 4.918.405 6.117.405Z"
    />
  </svg>
);
export default SvgNormal;
